"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const index_1 = require("../../index");
const react_router_dom_1 = require("react-router-dom");
const react_if_1 = require("react-if");
const Chevron_1 = require("./Chevron");
const overlays_1 = require("../../overlays");
exports.OsmosysAppNavItem = ({ children, to, chevron, tooltip, }) => {
    const comp = to ? (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: "px-2 flex-grow-1 flex-col-centered" }, children)) : (children);
    const inner = (react_1.default.createElement(index_1.OsmosysDiv, { flexRowFilled: true },
        react_1.default.createElement(react_if_1.When, { condition: !!chevron },
            react_1.default.createElement(Chevron_1.OsmosysAppNavChevron, null)),
        react_1.default.createElement(index_1.OsmosysDiv, { className: "text-dark", flexColCentered: true }, comp)));
    if (tooltip) {
        return react_1.default.createElement(overlays_1.OsmosysTooltip, { label: tooltip }, inner);
    }
    return inner;
};
//# sourceMappingURL=Item.js.map